export default __webpack_public_path__ + "static/media/compare-info.09f5589f.svg";